import {
  MAX_VENUE_AGGREGATE_WINDOW_DAYS,
  MIN_VENUE_AGGREGATE_WINDOW_DAYS,
  VENUE_AGGREGATE_WINDOW_DESCRIPTIONS,
  VENUE_AGGREGATE_WINDOW_LABELS,
  VenueAggregateWindowsConfig,
} from '@ivy-monorepo/shared'

type VenueAggregateWindowsEditorProps = {
  value: VenueAggregateWindowsConfig
  onChange: (value: VenueAggregateWindowsConfig) => void
}

const WINDOW_FIELDS = ['recentCheckinsWindowDays', 'recentViewsWindowDays'] as const

const VenueAggregateWindowsEditor = ({ value, onChange }: VenueAggregateWindowsEditorProps) => {
  const isValid = (field: keyof VenueAggregateWindowsConfig) =>
    Number.isInteger(value[field])
    && value[field] >= MIN_VENUE_AGGREGATE_WINDOW_DAYS
    && value[field] <= MAX_VENUE_AGGREGATE_WINDOW_DAYS

  const allValid = WINDOW_FIELDS.every(isValid)

  return (
    <div className="venue-aggregate-windows-editor">
      {WINDOW_FIELDS.map(field => (
        <label key={field} className="ticker-setting-field">
          <span className="ticker-setting-label">{VENUE_AGGREGATE_WINDOW_LABELS[field]}</span>
          <input
            type="number"
            className="map-filter-input ticker-setting-count-input"
            min={MIN_VENUE_AGGREGATE_WINDOW_DAYS}
            max={MAX_VENUE_AGGREGATE_WINDOW_DAYS}
            step={1}
            value={value[field]}
            onChange={e =>
              onChange({
                ...value,
                [field]: Number.parseInt(e.target.value, 10) || 0,
              })
            }
          />
          <span className="feature-flag-subtitle">{VENUE_AGGREGATE_WINDOW_DESCRIPTIONS[field]}</span>
        </label>
      ))}
      {!allValid ? (
        <div className="feature-flag-subtitle ticker-setting-error">
          Enter integers from {MIN_VENUE_AGGREGATE_WINDOW_DAYS} to {MAX_VENUE_AGGREGATE_WINDOW_DAYS} for each window.
        </div>
      ) : null}
    </div>
  )
}

export default VenueAggregateWindowsEditor
